export enum PlanningRoutesMessages {
    HTTP_ERROR = 'Ha ocurrido un error al enviar la solicitud al servidor.',
    INCOMPLETE_FORM = 'El formulario está incompleto.',
    DEACTIVE_AUTHORIZED_POINT = 'Se ha eliminado el punto autorizado.',
    UPDATED_AUTHORIZED_POINT = 'El punto autorizado se ha actualizado correctamente.',
    CREATED_AUTHORIZED_POINT = "El punto se ha creado correctamente",
    DEACTIVE_CRITIC_ZONE = 'Se ha eliminado la zona crítica.',
    UPDATED_CRITIC_ZONE = 'La zona crítica se ha actualizado correctamente.',
    CREATED_CRITIC_ZONE = 'La zona crítica se ha creado correctamente',
}
